import { useState } from 'react';
import { observer } from 'mobx-react-lite';
import Icon from '@components/Icon';
import { Button, Dropdown } from 'antd';
import stores from '@stores';

const items = [
    {
        key: 0.25,
        label: '25%'
    },
    {
        key: 0.5,
        label: '50%'
    },
    {
        key: 0.75,
        label: '75%'
    },
    {
        key: 1,
        label: '100%'
    },
    {
        key: 1.25,
        label: '125%'
    },
    {
        key: 1.5,
        label: '150%'
    },
    {
        key: 1.75,
        label: '175%'
    },
    {
        key: 2,
        label: '200%'
    }
];

export default observer(() => {
    const handleZoom = (key) => {
        if (key === 'in' || key === 'out') {
            const currentScale = stores.editor.app.tree.scale;
            
            let newScale;
            if (key === 'in') {
                newScale = currentScale + 0.125;
            } else {
                newScale = Math.max(0.125, currentScale - 0.125);
            }
            
            stores.editor.app?.tree.zoom(newScale);
        } else {
            stores.editor.app?.tree.zoom(key);
        }
        
        stores.editor.setScale(stores.editor.app.tree.scale);
    }
    const handleMenuClick = (item) => {
        const num = Number(item.key);
        if (num === 4) {
            stores.editor.app?.tree.zoom('fit', 100);
        } else {
            stores.editor.app?.tree.zoom(num);
        }
        stores.editor.setScale(stores.editor.app.tree.scale);
    }
    return (
        <div className="absolute z-10 top-4 right-4 flex items-center gap-2">
            <div className="flex bg-white dark:bg-gray-800 overflow-hidden rounded-full shadow-md border border-purple-200 dark:border-purple-900">
                <Button 
                    type="text" 
                    icon={<Icon.ZoomOut size={16} className="text-purple-500 dark:text-purple-400" />} 
                    onClick={() => handleZoom('out')} 
                    className="hover:bg-purple-50 dark:hover:bg-purple-900/30"
                />
                <Dropdown menu={{ items, onClick: handleMenuClick }} placement="bottom">
                    <Button 
                        type="text" 
                        className="font-medium text-purple-600 dark:text-purple-400 hover:bg-purple-50 dark:hover:bg-purple-900/30"
                    >
                        {stores.editor.scale}%
                    </Button>
                </Dropdown>
                <Button 
                    type="text" 
                    icon={<Icon.ZoomIn size={16} className="text-purple-500 dark:text-purple-400" />} 
                    onClick={() => handleZoom('in')} 
                    className="hover:bg-purple-50 dark:hover:bg-purple-900/30"
                />
            </div>
            <div className="rounded-full bg-white dark:bg-gray-800 shadow-md overflow-hidden border border-purple-200 dark:border-purple-900">
                <Button 
                    type="text" 
                    icon={<Icon.Maximize size={16} className="text-purple-500 dark:text-purple-400" />} 
                    onClick={() => handleMenuClick({key: 4})} 
                    className="hover:bg-purple-50 dark:hover:bg-purple-900/30"
                    title="适应屏幕"
                />
            </div>
        </div>
    )
});